function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SlotTypes } from './types';
import { ButtonGroupSpacer } from './styles';
import Button from '@doordash/component-button';

var Slot = function Slot(_ref) {
  var slot = _ref.slot,
      slotType = _ref.slotType;

  if (!slot) {
    // If we are doing a split layout, and there is not a slot used,
    // we want to add a <ButtonGroupSpacer />. This will help maintain behavior
    // and apperance no matter what combonation of actions/slots are used.
    return /*#__PURE__*/React.createElement(ButtonGroupSpacer, null);
  }

  if (typeof slot !== 'function' && slot.content) {
    // Have to wrap the content in a div, in order to allow the parent to apply a margin without collision
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, _extends({
      type: slotType === SlotTypes.Primary ? undefined : Button.Types.Tertiary,
      onClick: slot.onClick
    }, slot.buttonProps), slot.content));
  } // Have to wrap the content in a div, in order to allow the parent to apply a margin without collision


  return /*#__PURE__*/React.createElement("div", null, slot());
};

export default Slot;